import { MILESTONE_LEVELS } from '../config/exploreUnknownLevelingMilestones';

const MILESTONE_LEVEL_SET = new Set(MILESTONE_LEVELS);

/**
 * Bonus milestone levels newly reached on this XP grant (5, 10, 15, …).
 * Server `newMilestones` lists every level crossed; the unlock overlay only applies to bonus tiers.
 * @param {object|null|undefined} grant
 * @returns {number[]}
 */
export function getNewMilestonesFromGrant(grant) {
  if (!grant) {
    return [];
  }
  if (Array.isArray(grant.newMilestones) && grant.newMilestones.length > 0) {
    return grant.newMilestones
      .map((n) => Number(n))
      .filter((n) => Number.isInteger(n) && n > 0 && MILESTONE_LEVEL_SET.has(n));
  }
  if (grant.leveledUp !== true) {
    return [];
  }
  const levelBefore = Number(grant.levelBefore) || 1;
  const levelAfter = Number(grant.levelAfter) || levelBefore;
  if (levelAfter <= levelBefore) {
    return [];
  }
  return MILESTONE_LEVELS.filter((ml) => ml > levelBefore && ml <= levelAfter);
}
